import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from '../../Button/Button.esm.js';
import '@panwds/icons';
import '@popperjs/core';
import '../../Icon/ImgIcon.esm.js';
import '../../Icon/SemanticIcons.esm.js';
import '../../Button/ProgressButton.esm.js';
import '../../Button/CopyButton.esm.js';
import '@headlessui/react';
import '../../../utils/constants.esm.js';
import { Subtitle } from '../../Typography/Subtitle.esm.js';

function ModalWizardSummary({ children, }) {
    return (React.createElement("div", { className: "tw-flex tw-flex-col tw-space-y-4 tw-pt-1 tw-overflow-auto tw-scrollbar-default dark:tw-scrollbar-track-dark dark:tw-scrollbar-thumb-dark dark:tw-scrollbar-corner-dark" }, children));
}
function ModalWizardStepSummary({ items, onEdit, stepTitle, }) {
    const intl = useIntl();
    return (React.createElement("div", { className: "tw-flex tw-flex-col tw-space-y-2" },
        React.createElement("div", { className: "tw-box-border tw-border-solid tw-flex tw-justify-between tw-border-b tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-gray-200" },
            React.createElement(Subtitle, { as: "h4" }, stepTitle),
            onEdit && (React.createElement(Button, { addClassName: "tw-mr-1 tw-mb-1", appearance: "clear", onClick: onEdit, size: "sm" }, intl.formatMessage({ id: "PjdmrT", defaultMessage: [{ type: 0, value: "Edit" }] })))),
        React.createElement("dl", { className: "tw-box-border tw-m-0 tw-text-xs tw-flex tw-flex-col tw-space-y-2" }, items.map(([key, value], i) => {
            return (React.createElement("div", { key: i, className: "tw-text-xs tw-flex tw-flex-col tw-space-y-1" },
                React.createElement("dt", { className: "tw-text-secondary" }, key),
                React.createElement("dd", { className: "tw-box-border tw-m-0 tw-pl-8" }, value || "-")));
        }))));
}

export { ModalWizardStepSummary, ModalWizardSummary };
//# sourceMappingURL=ModalWizardStepSummary.esm.js.map
